import React from 'react';

export const WrenchSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_5996_19692)">
          <path d="M27.989 19.977C27.367 19.977 26.764 20.055 26.183 20.19L15.811 9.818C15.945 9.237 16.023 8.634 16.023 8.012C16.023 3.587 12.436 0 8.012 0C7.11 0 5.91 0.916 6.909 1.915L9.906 4.912C9.906 4.912 10.905 6.91 8.907 8.907C6.909 10.904 4.911 9.905 4.911 9.905L1.915 6.909C0.916 5.91 0 7.105 0 8.012C0 12.437 3.587 16.024 8.012 16.024C8.634 16.024 9.237 15.946 9.818 15.812L20.189 26.183C20.054 26.764 19.976 27.367 19.976 27.989C19.976 32.414 23.564 36 27.988 36C28.889 36 30.089 35.084 29.09 34.085L26.093 31.088C26.093 31.088 25.094 29.09 27.092 27.093C29.09 25.096 31.087 26.094 31.087 26.094L34.084 29.091C35.084 30.09 36 28.895 36 27.989C36 23.564 32.413 19.977 27.989 19.977Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_5996_19692">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18943)">
        <path d="M27.989 19.977C27.367 19.977 26.764 20.055 26.183 20.19L15.811 9.818C15.945 9.237 16.023 8.634 16.023 8.012C16.023 3.587 12.436 0 8.012 0C7.11 0 5.91 0.916 6.909 1.915L9.906 4.912C9.906 4.912 10.905 6.91 8.907 8.907C6.909 10.904 4.911 9.905 4.911 9.905L1.915 6.909C0.916 5.91 0 7.105 0 8.012C0 12.437 3.587 16.024 8.012 16.024C8.634 16.024 9.237 15.946 9.818 15.812L20.189 26.183C20.054 26.764 19.976 27.367 19.976 27.989C19.976 32.414 23.564 36 27.988 36C28.889 36 30.089 35.084 29.09 34.085L26.093 31.088C26.093 31.088 25.094 29.09 27.092 27.093C29.09 25.096 31.087 26.094 31.087 26.094L34.084 29.091C35.084 30.09 36 28.895 36 27.989C36 23.564 32.413 19.977 27.989 19.977Z" fill="#9EACB0" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18943">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}